<template>
  <div class="login-container">
    <div class="loginbox">
      <div class="rightBox">
        <img :src="banner_left" alt="">
      </div>
      <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on" label-position="left">
        <div class="logobox">
          <img :src="toplogo" alt="">
        </div>
        <h4 class="pagename">
          管理员登录
        </h4>
        <el-form-item prop="username" class="login_from_item">
          <!--<span class="svg-container">-->
          <!--<svg-icon icon-class="user" />-->
          <!--</span>-->
          <div class="input_title">
            账号
          </div>
          <el-input v-model="loginForm.username" name="username" type="text" auto-complete="on" placeholder="username" class="login_input" />
        </el-form-item>
        <el-form-item prop="password" class="login_from_item">
          <!--<span class="svg-container">-->
          <!--<svg-icon icon-class="password" />-->
          <!--</span>-->
          <div class="input_title">
            密码
          </div>
          <el-input
            v-model="loginForm.password"
            :type="pwdType"
            class="login_input"
            name="password"
            auto-complete="on"
            placeholder="password"
            @keyup.enter.native="handleLogin"
          />
          <span class="show-pwd" @click="showPwd">
            <svg-icon icon-class="eye" />
          </span>
        </el-form-item>
        <div class="remenberme">
          <el-checkbox v-model="checked">
            记住我
          </el-checkbox>
        </div>
        <el-form-item class="loginbtn">
          <el-button :loading="loading" type="primary" style="width:100%;" class="login_btn" @click.native.prevent="handleLogin">
            登录
          </el-button>
        </el-form-item>
        <div class="tips">
          <!--<el-button :plain="true" class="forgotpwd" @click="forgotpassword">-->
          <!--忘记密码-->
          <!--</el-button>-->
          <!--<el-button :plain="true" class="newUser" @click="rejister">-->
          <!--新用户注册-->
          <!--</el-button>-->
          <p>提示：本系统仅限获得授权的管理员登录</p>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import { isvalidUsername } from '@/utils/validate'
import { setCookie } from '@/utils/auth'

export default {
  name: 'Login',
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!isvalidUsername(value)) {
        callback(new Error('请输入正确的用户名'))
      } else {
        callback()
      }
    }
    const validatePass = (rule, value, callback) => {
      if (value.length < 5) {
        callback(new Error('密码不能小于5位'))
      } else {
        callback()
      }
    }
    return {
      banner_left: require('@/static/peng_login_left.png'),
      toplogo: require('@/static/logo_gengji1.png'),
      loginForm: {
        username: 'yangw',
        password: '123456'
      },
      loginRules: {
        username: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePass }]
      },
      loading: false,
      pwdType: 'password',
      redirect: undefined,
      checked: true
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  methods: {
    showPwd() {
      if (this.pwdType === 'password') {
        this.pwdType = ''
      } else {
        this.pwdType = 'password'
      }
    },
    handleLogin() {
      console.log(this.$route.query)
      this.$refs.loginForm.validate(valid => {
        // if (valid) {
        //   this.loading = true
        //   // /添加事件记住cookie
        //   if (this.checked) {
        //     // console.log(this.loginForm)
        //     // setCookie(this.loginForm.username,this.loginForm.password)
        //   }
        //   this.$store.dispatch('Login', this.loginForm).then(() => {
        //     this.loading = false
        //     this.$router.push({ path: this.redirect || '/index', query: this.$route.query })
        //   }).catch(() => {
        //     this.loading = false
        //   })
        // } else {
        //   return false
        // }
      })
    },
    forgotpassword() {
      this.$message('功能尚在开发')
    },
    rejister() {
      this.$message('功能尚在开发')
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
$bg:#2d3a4b;
$light_gray:#eee;

/* reset element-ui css */
.login-container {
  overflow: hidden;
  position: relative;
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;
    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
      &:-webkit-autofill {
        -webkit-box-shadow: 0 0 0px 1000px #fff inset !important;
        -webkit-text-fill-color: #999 !important;
        border: none !important;
      }
    }
  }
  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
}

</style>

<style rel="stylesheet/scss" lang="scss">
$bg:#2d3a4b;
$dark_gray:#889aa4;
$light_gray:#eee;
.login-container {
  /*position: fixed;*/
  height: 100%;
  width: 100%;
  /*top: 0;*/
  /*overflow: auto;*/
  /*background-image: url("/static/frameDefault/loginimg.jpg");*/
  background-repeat:no-repeat;
  background-size:cover;
  background-position:top center;
  .loginbox{
    height: 700px;
    width: 1250px;
    margin:20px auto;
    /*background-image: url("/static/frameDefault/logingqimg.png");*/
    position: relative;
    .rightBox{
      display: inline-block;
      width: 718px;
      height: 700px;
      float: left;
      font-size: 0;
      border-left: 2px solid rgba(57,59,57,.3);
      -moz-box-shadow:1px 1px 3px #49443e;
      -webkit-box-shadow:1px 1px 3px #49443e;
      box-shadow:1px 1px 3px #49443e;
      img{
        width: 718px;
        height: 700px;
      }
    }
  }
  .login-form {
    width: 350px;
   height: 630px;
    max-width: 100%;
    padding: 55px 90px 15px 90px;
    background-color: #fff;
    float: right;

  }
  //修改自带input框成下划线样式
  .login_from_item{
    background-color:#FFFFFF;
    border-bottom: 1px solid #eeeeee;
  }
  ///修改表单输入框样式
  .el-input__inner{
    padding: 12px 5px 12px 0px !important;
    color:#747c88 !important;
    font-weight: 500;
  }
  //修改按钮样式
  .el-button--primary{
    background-color: #304156;
    border-color: #304156;
  }
  .remenberme{
    margin-top:25px;
    margin-bottom: 35px;
  }
  .input_title{
    color: #bfbfbf;
    font-size:14px;
    font-weight: 600;
  }
  .tips {
    font-size: 14px;
    color: #b0b0b0;
    margin-top: 80px;
    p{
      text-align: center;
    }
    .span_rejister{
      color: #304156;
      float: right;
      &:hover{
        color:#0ce2fb;
      }
    }
  }
  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }
  .logobox{
    height: 39px;
    line-height: 39px;
    margin-bottom: 40px;
    margin-left: -20px;

  }
  .title {
    font-size: 26px;
    font-weight: 400;
    color: $light_gray;
    color: #304156;
    font-weight: bold;
    display: inline-block;
    margin: 0;
    vertical-align: 0.15em;
  }
  ///增加“用户登录”小标题
  .pagename{
    text-align: center;
    color: #7f6a59;
    font-weight:500;
    font-size: 18px;
    margin: 20px 0;
  }
  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
}
  ///忘记密码
  .forgotpwd{
    color: #b0b0b0;
    font-size: 12px;
    border: none;
  }
  //新用户注册
  .newUser{
    border: none;
    font-size: 12px;
    color: #304156;
    float: right;
  }
.loginbtn{
  margin-bottom: 6px;
  color: #7d6a5b;
  .login_btn{
    background-color: #7d6a5b;
    border-color: #7d6a5b;
  }
}

</style>
